// extracted by mini-css-extract-plugin
export default {"page":"Xea-z","cartModal":"Yea-z","checkout":"Zea-z","placeholder":"_ea-z","account":"afa-z"};